import React from 'react';
import ModuleTopic from '../../components/ModuleTopic';

interface ITopicProps {
  settings: any;
}

const TopicData: React.FunctionComponent<ITopicProps> = ({ settings }) => (
  <ModuleTopic settings={settings} moduleKey="data" />
);

export default TopicData;
